export const MAINMAP_MAP_MODULEBAR_CONSTANT = {
  MODULE_BAR_MENU_LIST: 'LI/MAINMAP/MODULEBAR/MENU/LIST',
  MODULE_BAR_MENU_SELECTED: 'LI/MAINMAP/MODULEBAR/MENU/SELECTED',
  MODULE_BAR_SUBMENU_LIST: 'LI/MAINMAP/MODULEBAR/SUBMENU/LIST',
  MODULE_BAR_SUBMENU_SELECTED: 'LI/MAINMAP/MODULEBAR/SUBMENU/SELECTED',
  MODULE_BAR_RESET_STATE: 'LI/MAINMAP/MODULEBAR/RESET_STATE',
};
